import { MuiImage } from "@repo/ui";
import contactInfoCheckImage from "@repo/ui/assets/images/login-desktop.png";
import { type FC } from "react";


export const LoginImage: FC<{ opacity?: boolean }> = ({ opacity }) => {
	return (
		<MuiImage
			src={contactInfoCheckImage}
			sx={{
				position: "absolute",
				zIndex: -1,
				left: "-95px",
				opacity: opacity ? 0.5 : 1,
				width: 824
			}} />
	);
}
